import React from 'react';
import { SiMinds } from 'react-icons/si';
import { IoSchoolOutline } from 'react-icons/io5';
import { GiNetworkBars } from 'react-icons/gi';

const About = () => {
  return (
    <div name='about' className='w-full lg:min-h-[70vh] bg-white text-gray-700 flex flex-col justify-center items-center lg:pt-6 pt-10 pb-28'>
      <h2 className="text-xl font-bold mt-6 lg:mt-[30px]">What Are We Doing?</h2>
      <h3 className="text-3xl font-bold mt-2 mb-4 px-5">Uplifting Lives And Creating Opportunities Through Education.</h3>
      <div className="w-full max-w-7xl flex flex-col lg:flex-row justify-between mt-10 lg:space-x-6 h-[450px] lg:mb-0 mb-20 gap-3">
        
        {/* Card 1 */}
        <div className="lg:w-1/3 mx-4 lg:mx-0">
          <div className="bg-white rounded-lg p-8 shadow-lg hover:bg-green-50 transition-colors duration-300 h-full">
            <SiMinds className="text-[#15381b] text-5xl mx-auto my-10" />
            <h4 className="text-2xl font-bold mb-8 text-center">Character Development</h4>
            <p>To promote social responsibility, the development of character and the formation of a responsible public opinion in accordance with Christian principles and ideals.</p>
          </div>
        </div>
        
        {/* Card 2 */}
        <div className="lg:w-1/3 mx-4 lg:mx-0">
          <div className="bg-[#15381b] text-white rounded-lg p-8 shadow-lg h-full">
            <IoSchoolOutline className="text-5xl mx-auto my-10" />
            <h4 className="text-2xl font-bold mb-8 text-center">Education</h4>
            <p className='font-satoshi'>
              To develop centres of primary, secondary, tertiary and professional education. To organize a
              variety of educational programs, including cultural events, vocational guidance, adult
              education, conferences, seminars and courses.
            </p>
          </div>
        </div>
        
        {/* Card 3 */}
        <div className="lg:w-1/3 mx-4 lg:mx-0">
          <div className="bg-white rounded-lg p-8 shadow-lg hover:bg-green-50 transition-colors duration-300 h-full">
            <GiNetworkBars className="text-[#15381b] text-5xl mx-auto my-10" />
            <h4 className="text-2xl font-bold mb-8 text-center">Assisting People</h4>
            <p>To assist, by the provision of grants, scholarships and study loans, the
              pursuit of education or research by individual deserving students, especially those from
              economically disadvantaged background.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
